import { gql } from 'react-apollo';

export default gql`
  mutation submitReply($input: CommentInput!) {
    submitReply(input: $input) {
      _id

      content
      title
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/submitReply.js